import { useState, useEffect } from "react";

const HeaderSimple = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 px-4 md:px-6 py-3 md:py-4 flex items-center justify-between transition-colors duration-300 ${
        isScrolled ? "bg-white text-black shadow" : "text-white"
      }`}
    >
      <div className="flex items-center gap-2 md:gap-3">
        <img
          src={isScrolled ? "/LogoB.svg" : "/LogoW.svg"}
          alt="Palette Logo"
          className="h-6 md:h-8 transition duration-300"
        />
      </div>
      <nav className="flex text-base font-semibold items-center justify-end gap-2 md:gap-4 text-xs md:text-sm">
        <a
          href="mailto:isjung@pltt.xyz"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full transition
            ${
              isScrolled
                ? " hover:bg-gray-100"
                : " text-white hover:bg-white/10"
            }`}
        >
          메일 보내기
        </a>
        <a
          href="http://pf.kakao.com/_bEXSn/chat"
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center gap-2 px-4 py-2 rounded-full transition
            ${
              isScrolled
                ? "  bg-yellow-400 hover:bg-yellow-500"
                : " text-white hover:bg-yellow-500 hover:text-black"
            }`}
        >
          카카오 문의하기
        </a>
      </nav>
    </header>
  );
};

export default HeaderSimple;
